import gql from 'graphql-tag'

export const fileProcessing = gql`
  mutation fileProcessing($idDeal:Int!,$idFileProcess: Int!){
    start_processing(id_deal: $idDeal, id_file_process: $idFileProcess)
  }
`
